<template>
  <Modal v-model="editRoleModal" :title="editRoleTitle" width="1200" :transfer="false" class-name="editRoleModalStyle"
    :mask-closable="false" @on-visible-change="editRoleChange" :style="setCssVar">
    <Form ref="editRoleModalForm" :model="editRoleModalForm" :rules="ruleValidate" :label-width="100" @submit.native.prevent>
      <Row type="flex" :gutter="gutterItem" style="width: 60%; padding-left: 17px;" class="mb10" v-if="roleType ==='look'">
        <Col :span="ItemCol" class="mb10">
          <span class="basic_title">{{ $t('key1005177') }}</span>
          <span class="basic_txt">{{ editRoleModalForm.roleName }}</span>
        </Col>
        <Col :span="ItemCol" class="mb10">
          <span class="basic_title">{{ $t('key1005839') }}</span>
          <span class="basic_txt">{{ editRoleModalForm.remark }}</span>
        </Col>
      </Row>
      <Row v-else style="width: 60%;">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1005177')" prop="roleName">
            <Input :placeholder="$t('key1005178')" :maxlength="20" v-model.trim="editRoleModalForm.roleName" clearable></Input>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1005839')" prop="remark">
            <Input :placeholder="$t('key1005840')" v-model.trim="editRoleModalForm.remark" clearable></Input>
          </Form-item>
        </Col>
      </Row>
      <Card :bordered="false" dis-hover class="card_box_styles">
        <template #title>
          <div class="flex">
            <h2 class="title_box">{{ $t('key1005841') }}</h2>
            <Checkbox
              style="font-size: 14px !important;"
              class="ml15"
              :indeterminate="indeterminateAllPages"
              v-model="checkBoxGroupAllValue"
              @on-change="changeModulePageAllRole"
              v-if="roleType !=='look'">
              {{ $t('key1000790') }}
            </Checkbox>
          </div>
        </template>
        <Tabs class="vertical-tabs" :class="setTabsWidth" :animated="false" v-model="tabsName">
          <TabPane v-for="(item,index) in tabPaneList" :key="index" :name="String(index)" :label="item.name">
            <Checkbox
              :indeterminate="item.indeterminatePagesAll"
              v-model="item.checkBoxGroupValueAll"
              class="select_all"
              @click.prevent.stop.native="changeModulePageRoleAll($event, item)"
              v-if="roleType !=='look'">
              {{ $t('key1000790') }}
            </Checkbox>
            <template v-if="item.children.length >0">
              <Collapse v-model="collapseValue">
                <template>
                  <Panel v-for="(ele, idx) in item.children" :name="ele.menuKey" :key="ele.menuKey + '_' + idx">
                    <h2 class="title" v-if="roleType ==='look'">{{ ele.name }}</h2>
                    <Checkbox v-else class="title" v-model="ele.checkBoxGroupValue" :indeterminate="ele.indeterminatePages"
                      @click.prevent.stop.native="changePageRoleAll($event, ele, item)">
                      {{ ele.name }}
                    </Checkbox>
                    <template #content>
                      <Checkbox-group class="page_role_box" v-model="ele.checkBoxGroupList" @on-change="(value)=> selectRoleList(value, ele, item)">
                        <template>
                          <div class="roleItem" v-for="(talg, ids) in ele.checkBoxList" :key="ids">
                            <span class="page_role_item_title" v-if="roleType ==='look' && talg.checked">{{ talg.operName }}</span>
                            <Checkbox v-if="roleType !=='look'" :label="talg.operId" :title="talg.operName">
                              <span class="page_role_item_title">{{ talg.operName }}</span>
                            </Checkbox>
                          </div>
                        </template>
                      </Checkbox-group>
                    </template>
                  </Panel>
                </template>
              </Collapse>
            </template>
          </TabPane>
        </Tabs>
      </Card>
    </Form>
    <template #footer>
      <Button @click="editRoleModal = false">{{ $t('key1000112') }}</Button>
      <template v-if="getPermission('role_update')">
        <Button type="primary" v-if="roleType === 'look'" @click="editBtn">{{ $t('key1000985') }}</Button>
        <Button type="primary" v-else @click="editRoleModalBtn">{{ $t('key1000111') }}</Button>
      </template>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import distributorMenu from '@/config/menu/distributor';
import {hideAlibabaDistributorsMenuData, isAlibabaDistributor, commonLocalStorage, isChineseLanguage} from "@/utils/common";

export default {
  name: "editRoleModal",
  mixins: [Mixin],
  data() {
    return {
      ItemCol: 24,
      editRoleTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005837'),
      editRoleModal: false,
      editRoleModalForm: {
        roleName: '',
        remark: ''
      },
      ruleValidate: {
        roleName: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005175'), trigger: 'blur'}
        ],
      },
      tabsName: '0',
      tabPaneList: [],
      roleType: 'add',
      collapseValue: [],
      roleId: null,
      originalObj: {},
      indeterminateAllPages: null,
      checkBoxGroupAllValue: false,
    }
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    setTabsWidth() {
      return isChineseLanguage() ? 'vertical-tabs-width-zh' : 'vertical-tabs-width-en';
    },
    setCssVar() {
      return {
        '--subject-color': isAlibabaDistributor() ? '#2D8CF0' : '#FD5425'
      };
    },
    // 在线支付渠道配置
    onlineBalanceRecharge() {
      const obj = commonLocalStorage.getItem('configurationItemInfo') ?? this.$store.state.configurationItemInfo;
      return obj?.onlineBalanceRecharge.length > 0 || false;
    },
  },
  methods: {
    // 初始化数据
    initFun(type, data) {
      let titleObj = {
        add: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005837'),
        edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005176'),
        look: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005838')
      };
      this.editRoleTitle = titleObj[type];
      this.roleType = type;
      this.tabsName = '0';
      if (type !== 'add') {
        this.editRoleModalForm.roleName = data.roleName;
        this.editRoleModalForm.remark = data.remark;
        this.roleId = data.roleId;
        this.originalObj = data;
      } else {
        this.editRoleModalForm.roleName = '';
        this.editRoleModalForm.remark = '';
      }
      let distributorMenuData = JSON.parse(JSON.stringify(distributorMenu.menu));

      // 如果当前分销商是阿里国际分销，需要过滤掉相关菜单
      let menuData = hideAlibabaDistributorsMenuData(distributorMenuData);
      (async () => {
        // YMS上架工具
        let merchant = this.$store.state.erpConfig.merchant;
        let newList = [];
        if (merchant.listingStatus !== '1') {
          await this.getListingMenuData().then((data) => {
            if (data && data.length > 0) {
              let list = [
                {
                  name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000007'),
                  menuKey: 'distributor_shelfTools',
                  children: data
                }
              ];
              newList = [...menuData, ...list];
            }
          });
        } else {
          newList = [...menuData];
        }
        await this.handleMenuList(newList)
        await this.getRoleData(this.roleId);
      })();
    },
    // 获取角色的详情数据
    getRoleData(roleId) {
      let v = this;
      v.axios.get(api.get_role + roleId + '?subsystemCode=yms-distributor-service', {loading: true}).then(response => {
        if (response.data.code === 0) {
          v.editRoleModal = true;
          let data = response.data.datas || [];
          data = v.processingPermissionValues(data);
          if (data.length > 0) {
            if (v.tabPaneList.length > 0) {
              let newList = [];
              v.tabPaneList.map((talg) => {
                newList.push(...talg.children);
              });
              if (newList.length > 0) {
                newList.map((item) => {
                  data.map((ele) => {
                    if (item.menuKey === ele.menuId) {
                      item.checkBoxList.push(ele);
                      if (ele.checked) {
                        item.checkBoxGroupList.push(ele.operId);
                        item.checked = true;
                      }
                      if (item.checkBoxGroupList.length > 0) {
                        if (item.checkBoxGroupList.length === item.checkBoxList.length) {
                          item.checkBoxGroupValue = true;
                          item.indeterminatePages = false;
                        } else {
                          item.checkBoxGroupValue = false;
                          item.indeterminatePages = true;
                        }
                      }
                      setTimeout(() => {
                        v.tabPaneList.map((talg) => {
                          let currentTalgAll = talg.children.every((k) => {
                            return k.checkBoxGroupValue
                          });
                          if (currentTalgAll) {
                            talg.checkBoxGroupValueAll = true;
                            talg.indeterminatePagesAll = false;
                          } else {
                            let currentTalg = talg.children.some((k) => {
                              return k.checkBoxGroupValue
                            });
                            if (currentTalg) {
                              talg.checkBoxGroupValueAll = false;
                              talg.indeterminatePagesAll = true;
                            } else {
                              talg.checkBoxGroupValueAll = false;
                              talg.indeterminatePagesAll = false;
                            }
                          }
                        });
                      }, 800);
                    }
                  })
                });
              }
              v.$forceUpdate();
            }
          }
        }
      });
    },
    // 根据配置项过滤掉指定权限值
    processingPermissionValues(data) {
      let keyList = [];
      if (!this.onlineBalanceRecharge) {
        keyList.push('ymsDistributorMerchantRechargeRecord_alipay');
      }
      return data.filter((item) => {
        return !keyList.includes(item.resource)
      });
    },
    // 处理权限菜单数据
    handleMenuList(menuData) {
      let v = this;
      if (menuData && menuData.length > 0) {

        function handleData(data, result = []) {
          data.forEach(node => {
            if (!node.menuHide && !node.hideMenu) {
              result.push(node)
            }
            node.children && handleData(node.children, result)
          });
          return result
        }

        let newData = menuData.filter((item) => {
          return !item.menuHide
        });
        newData.map((item) => {
          item.indeterminatePagesAll = false;
          item.checkBoxGroupValueAll = false;
          if (item.children && item.children.length > 0) {
            let list = handleData(item.children)
            if (list && list.length > 0) {
              list.map((ele) => {
                ele.checkBoxList = [];
                ele.checkBoxGroupValue = false;
                ele.checkBoxGroupList = [];
                ele.indeterminatePages = false;
              });
              item.children = list;
            }
          } else {
            item.children = [{
              name: item.name,
              menuKey: item.menuKey,
              checkBoxList: [],
              checkBoxGroupValue: false,
              checkBoxGroupList: [],
              indeterminatePages: false,
            }];
          }
        });
        v.tabPaneList = newData;
        v.handleCollapse(newData);
      }
    },
    // 切换到编辑状态
    editBtn() {
      this.resetData();
      this.initFun('edit', this.originalObj);
    },

    // 新增、编辑角色的确定按钮
    editRoleModalBtn() {
      let v = this;
      let url = '';
      let text = '';
      let method = '';
      let newList = [];
      let operIdList = [];
      v.tabPaneList.map((item) => {
        newList.push(...item.children);
      });
      if (newList.length > 0) {
        newList.map((item) => {
          operIdList.push(...item.checkBoxGroupList)
        });
      }
      let query = {
        operIdList: operIdList,
        roleName: v.editRoleModalForm.roleName,
        remark: v.editRoleModalForm.remark
      };
      // 新增角色
      if (v.roleType === 'add') {
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000776');
        method = 'post';
        url = api.post_role;
      }
      // 编辑角色
      else if (v.roleType === 'edit') {
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001205');
        method = 'put';
        url = api.put_role;
        query.roleId = v.roleId;
      }
      v.$refs['editRoleModalForm'].validate((valid) => {
        if (valid) {
          v.axios[method](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.editRoleModal = false;
              v.$Message.success(text);
              v.$emit('updateData');
            }
          });
        }
      });
    },
    // 全选所有模块的页面权限
    changeModulePageAllRole(value) {
      let v = this;
      if (value) {
        v.tabPaneList.forEach((item) => {
          item.children.map((ele) => {
            ele.checkBoxGroupList = ele.checkBoxList.map((talg) => {
              return talg.operId;
            });
            ele.checkBoxGroupValue = true;
            ele.indeterminatePages = false;
          });
          item.indeterminatePagesAll = false;
          item.checkBoxGroupValueAll = value;
        });
      } else {
        v.tabPaneList.forEach((item) => {
          item.children.map((ele) => {
            ele.checkBoxGroupList = [];
            ele.checkBoxGroupValue = false;
            ele.indeterminatePages = false;
          });
          item.indeterminatePagesAll = false;
          item.checkBoxGroupValueAll = value;
        });
      }
    },
    // 全选整个模块的权限
    changeModulePageRoleAll(event, data) {
      let v = this;
      data.checkBoxGroupValueAll = !data.checkBoxGroupValueAll;
      // 勾选中的状态
      if (data.checkBoxGroupValueAll) {
        data.children.map((item) => {
          item.checkBoxGroupList = item.checkBoxList.map((ele) => {
            return ele.operId;
          });
          item.checkBoxGroupValue = true;
          item.indeterminatePages = false;
        });
        data.indeterminatePagesAll = false;
      } else {
        data.children.map((item) => {
          item.checkBoxGroupList = [];
          item.checkBoxGroupValue = false;
          item.indeterminatePages = false;
        });
        data.indeterminatePagesAll = false;
      }
      v.$forceUpdate();
    },
    // 全选单个页面权限
    changePageRoleAll(event, ele, item) {
      let v = this;
      ele.checkBoxGroupValue = !ele.checkBoxGroupValue;
      // 勾选中的状态
      if (ele.checkBoxGroupValue) {
        ele.checkBoxGroupList = ele.checkBoxList.map((data) => {
          return data.operId;
        });
        ele.indeterminatePages = false;
      } else {
        ele.checkBoxGroupList = [];
        ele.indeterminatePages = false;
      }
      let talg = item.children.every((k) => {
        return k.checkBoxGroupValue
      });
      if (talg) {
        item.checkBoxGroupValueAll = true;
        item.indeterminatePagesAll = false;
      } else {
        let j = item.children.some((k) => {
          return k.checkBoxGroupValue
        });
        if (j) {
          item.checkBoxGroupValueAll = false;
          item.indeterminatePagesAll = true;
        } else {
          if (ele.checkBoxGroupList.length > 0) {
            item.checkBoxGroupValueAll = false;
            item.indeterminatePagesAll = true;
          } else {
            item.checkBoxGroupValueAll = false;
            item.indeterminatePagesAll = false;
          }
        }
      }
      v.$forceUpdate();
    },
    // 单个勾选中权限
    selectRoleList(value, ele, item) {
      if (ele.checkBoxGroupList.length === ele.checkBoxList.length) {
        ele.checkBoxGroupValue = true;
        ele.indeterminatePages = false;
      } else {
        if (ele.checkBoxGroupList.length > 0) {
          ele.checkBoxGroupValue = false;
          ele.indeterminatePages = true;
        } else {
          ele.checkBoxGroupValue = false;
          ele.indeterminatePages = false;
        }
      }

      let talg = item.children.every((k) => {
        return k.checkBoxGroupValue
      });
      if (talg) {
        item.checkBoxGroupValueAll = true;
        item.indeterminatePagesAll = false;
      } else {
        let j = item.children.some((k) => {
          return k.checkBoxGroupValue
        });
        if (j) {
          item.checkBoxGroupValueAll = false;
          item.indeterminatePagesAll = true;
        } else {
          if (ele.checkBoxGroupList.length > 0) {
            item.checkBoxGroupValueAll = false;
            item.indeterminatePagesAll = true;
          } else {
            item.checkBoxGroupValueAll = false;
            item.indeterminatePagesAll = false;
          }
        }
      }
      this.$forceUpdate();
    },
    // 重置数据
    resetData() {
      this.$refs['editRoleModalForm'].resetFields();
      this.tabPaneList = [];
      this.collapseValue = [];
      this.roleType = 'add';
      this.roleId = null;
    },
    // 监听弹窗
    editRoleChange(value) {
      if (!value) {
        this.resetData();
      }
    },
    // 默认展开权限面板
    handleCollapse(data) {
      let v = this;
      v.collapseValue = [];
      let list = [];
      if (data.length > 0) {
        data.map((ele) => {
          if (ele.children && ele.children.length > 0) {
            ele.children.map((talg) => {
              list.push(talg.menuKey)
            })
          } else {
            list.push(ele.menuKey)
          }
        })
        if (list.length > 0) {
          v.collapseValue = v.uniqueFunc(list);
        }
      }
    },
    // 获取listing上架工具的相关菜单数据
    getListingMenuData() {
      let v = this;
      let newList = [];
      return new Promise((resolve, reject) => {
        v.axios.get(api.get_getShelfToolModules).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            if (data.length > 0) {
              data.map((item) => {
                newList.push({
                  name: item.moduleName,
                  menuKey: item.moduleId
                })
              });
            }
            resolve(newList);
          }
        });
      });
    }
  },
  watch: {
    tabPaneList: {
      handler(data) {
        if (data.length > 0) {
          let talg = data.every((item) => {
            return item.checkBoxGroupValueAll
          });
          if (talg) {
            this.checkBoxGroupAllValue = true;
            this.indeterminateAllPages = false;
          } else {
            let talgFalse = data.every((item) => {
              return item.checkBoxGroupValueAll === false && item.indeterminatePagesAll === false
            });
            if (talgFalse) {
              this.checkBoxGroupAllValue = false;
              this.indeterminateAllPages = null;
            } else {
              let currentTalg = data.some((item) => {
                return item.checkBoxGroupValueAll || (item.checkBoxGroupValueAll === false && item.indeterminatePagesAll === true)
              });
              if (currentTalg) {
                this.checkBoxGroupAllValue = false;
                this.indeterminateAllPages = true;
              }
            }
          }
        }
        this.$forceUpdate();
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .editRoleModalStyle {
  .card_box_styles {
    .title_box {
      color: #333333;
      font-weight: bold;
      font-size: 17px;
    }
  }

  .ivu-collapse {
    max-height: 550px;
    overflow-y: auto;

    .ivu-collapse-header {
      display: flex;
      align-items: center;

      .title {
        font-weight: bold;
        color: #000;
        font-size: 14px;
        display: inline-block;
      }
    }

    .ivu-collapse-content {
      .page_role_box {
        display: flex;
        flex-wrap: wrap;

        .roleItem {
          margin: 0 35px 12px 0;
        }
      }
    }
  }

  .ivu-modal-body {
    height: 680px;
    overflow-y: auto;
  }

  .ivu-card-body {
    padding: 16px 0;
  }

  .ivu-card-head {
    padding: 14px 0;
  }

  .vertical-tabs {
    display: flex;

    .ivu-tabs-bar {
      border-radius: 3px;
      border: 1px solid #dcdee2;
      box-sizing: border-box;
      margin: 0 15px 0 0;
      overflow: hidden;

      .ivu-tabs-nav-scroll {
        display: flex;
        justify-content: center;
      }
    }

    .ivu-tabs-nav {
      display: flex;
      flex-direction: column;

      .ivu-tabs-tab {
        margin-right: 0;
        padding: 8px 12px;
      }

      .ivu-tabs-ink-bar {
        display: none;
      }

      .ivu-tabs-tab-active {
        position: relative;

        &:after {
          position: absolute;
          content: ' ';
          display: inline-block;
          height: 2px;
          box-sizing: border-box;
          background-color: var(--subject-color);
          width: 100%;
          left: 0;
          bottom: 2px;
        }
      }
    }

    .ivu-tabs-content {
      flex: 1;
      border-radius: 3px;
      border: 1px solid #dcdee2;
      box-sizing: border-box;
      padding: 15px;
      overflow: hidden;

      .select_all {
        position: relative;
        margin-bottom: 12px;
        font-size: 14px !important;
        left: 947px;
      }
    }
  }

  .vertical-tabs-width-zh .ivu-tabs-bar {
    min-width: 120px;
  }

  .vertical-tabs-width-en .ivu-tabs-bar {
    min-width: 210px;
  }
}
</style>